module.exports = __webpack_public_path__ + "static/image/service/pc/takeout@3x.jpg?e3cac148";